// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"Brands_TheComp__twCv2"};